var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7027 22.532L44.7024 32.1097C44.6258 35.8895 41.6327 38.9595 37.8615 38.9595C35.5979 38.9595 33.7568 37.1158 33.7568 34.8496V23.9174C33.7568 21.6512 35.5954 19.8041 37.8615 19.8041C38.7876 19.8041 39.6496 20.0369 40.4526 20.3752C39.3751 11.5177 31.884 4.76453 22.8108 4.76453C13.7377 4.76453 6.24569 11.5177 5.16905 20.377C5.97204 20.035 6.83403 19.8041 7.76016 19.8041C10.0263 19.8041 11.8649 21.6512 11.8649 23.9174V34.8548C11.8649 37.1124 10.0263 38.9595 7.76016 38.9595C3.98809 38.9595 0.995909 35.8912 0.995909 32.1131L0.918945 22.5406C0.918945 10.4658 10.7361 0.648682 22.8108 0.648682C34.8599 0.648682 44.6685 10.4402 44.6258 22.4807C44.6258 22.4978 44.6258 22.5149 44.7027 22.532Z",
    fill: "#01BABF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.61b9f960ac52ad1b4c72f1703918465e.svg";
export { ForwardRef as ReactComponent };